export default __webpack_public_path__ + "static/ai-marketing-7--mobile-19001f3472962c570d8466930f50989b.jpg";